import type { FaireProductEntity } from "../../entity_types/product";

export const p_s9usr5zb2q: FaireProductEntity = {
  token: "p_s9usr5zb2q",
  type: "product",
  name: "Wholesale Lot 1 lb Natural Clear Quartz Double Terminated",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl:
    "https://cdn.faire.com/fastly/ac40f75e4380e7878fdfd37a1b20677ddc25716084568bfce01936344c004d7c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/80d9c594059dbc90dcff6ecacaedfe2a96907bdc22c5c3010a3d30ce1b918c59.jpeg",
    "https://cdn.faire.com/fastly/8398dff435ea204f50b82610c979879f499b2d5ecd5931ca90ae28e61c5d4152.jpeg",
    "https://cdn.faire.com/fastly/d52eea860389a6abe37eeb1c6e7e9283ea9fd2e46e3ae48458cba084b850562a.jpeg",
    "https://cdn.faire.com/fastly/9190b7f8419ae564307319a2135d067dac4669d598eb7067e0af287925b28b34.jpeg",
    "https://cdn.faire.com/fastly/8cbc5212f4c74638f6b8ee2c58ceb926f961d1532697bd55f75e435a1ce8c9c6.jpeg",
  ],
  priceDollars: 69.28,
  description:
    "Wholesale Lot 1 Lb Natural Clear Quartz Double Terminated Point Wand Polish Crystal. Roughly 1” - 3” in length, 9 to 16 pcs per lot. Condition is New. Free local pickup in Brooklyn, New York. Stones, stone wholesale, crystals, crystal bulk, crystal wholesale, spiritual, spiritual items, meditation, metaphysical wholesale. ",
  tags: [],
  msrpDollars: 207.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:44.306Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
